var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product-aside-cart-container" }, [
    _c("div", { staticClass: "product-aside-cart-item" }, [
      _c(
        "button",
        {
          staticClass: "btn--product-aside btn--product-aside--full",
          attrs: { type: "button", "data-test": "personalisationButton" },
          on: { click: _vm.triggerPersonalisationModel },
        },
        [_vm._v("\n      " + _vm._s(_vm.personalisationLabel) + "\n    ")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }